import React from "react";
import "./PlaceHolder.css";

function PlaceHolder(props) {
  const defaultStyles = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "50px",
    marginBottom: "10px",
    opacity: 0.5,
  };
  const combinedStyles = { ...defaultStyles, ...props.styles };
  return (
    <div
      style={combinedStyles}
      onClick={props.onclick}
      onMouseOver={props.mouseOver}
      onMouseLeave={props.mouseLeave}
    >
      {props.children}
    </div>
  );
}
export default PlaceHolder;
